import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.HELP_FEEDBACK,
        content: i18n.t<string>('帮助与反馈'),
        preventDismiss: true,
        respectOffline: true,
    },
    {
        name: ActionType.HELP,
        content: i18n.t<string>('帮助中心'),
    },
    {
        name: ActionType.REPORT,
        content: i18n.t<string>('反馈'),
    },
    {
        name: ActionType.ACCUSATION,
        content: i18n.t<string>('举报'),
    },
    {
        name: ActionType.PRIVACY,
        content: i18n.t<string>('隐私'),
    },
    {
        name: ActionType.PRIVACY_POLICY,
        content: i18n.t<string>('隐私政策'),
    },
    {
        name: ActionType.THIRD_PARTY_DATA_SHARING,
        content: i18n.t<string>('第三方共享信息清单'),
    },
    {
        name: ActionType.THIRD_AUTHORIZATION_MANAGEMENT,
        content: i18n.t<string>('第三方应用授权管理'),
    },
    {
        name: ActionType.PERSONAL_INFO_COLLECTION,
        content: i18n.t<string>('个人信息收集清单'),
    },
    {
        name: ActionType.INFRINGEMENT,
        content: i18n.t<string>('侵权指引'),
    },
    {
        name: ActionType.APPEAL,
        content: i18n.t<string>('受限文档申诉'),
    },
    {
        name: ActionType.SHORTCUT_KEY,
        content: i18n.t<string>('快捷键'),
    },
    {
        name: ActionType.ABOUT,
        content: i18n.t<string>('功能介绍'),
    },
    {
        name: ActionType.COMMUNITY_CONVENTION,
        content: i18n.t<string>('平台公约'),
    },
    {
        name: ActionType.SLIDE_VERSION,
        content: `${i18n.t<string>('版本：')}3.0`,
    },
];
